(function() {
    'use strict';
    angular.module('sgnmrApp').controller('NormaHistoricoController', NormaHistoricoController);
    NormaHistoricoController.$inject = ['entity', 'historicos'];

    function NormaHistoricoController(entity, historicos) {
        var vm = this;
        vm.norma = entity;            // la norma vigente sobre la que se dio clic
        vm.historicos = historicos;   // sus históricos, del más reciente al más antiguo
    }
})();
